'use strict';

var UserStore = require('../stores/UserStore'),
    parseStampSegment = require('../utils/parseStampSegment'),
    AlertActionCreators = require('../actions/AlertActionCreators'),
    AlertTypes = require('../constants/AlertTypes'),
    { isMobile } = require('../utils/Browser');

function getDraftPreviewRedirectTarget(stampSegment) {

  // It's just a preview so we won't try to catch all the edge cases like in
  // DraftComposePage. Preview page works on mobile, and anyone can view
  // preview page for server drafts.

  const { isServerDraft } = parseStampSegment(stampSegment);
  if (!isServerDraft) {
    if (!UserStore.isAuthenticated()) {
      return ['feed'];
    }

    if (isMobile()) {
      AlertActionCreators.showAlert(AlertTypes.EDITOR_DESKTOP_ONLY, { hideOnRouteChange: false });
      return ['feed'];
    }
  }

  return [];
}

module.exports = getDraftPreviewRedirectTarget;


/** WEBPACK FOOTER **
 ** ./utils/getDraftPreviewRedirectTarget.js
 **/